<template>
  <v-layout column wrap>
    <v-flex xs12 v-if="!requestAgreementLoading">
      <v-flex xs12>
        <v-img
          contain
          max-width="100%"
          :src="agreementDisplayImage"
          alt="agreement related image"/>
      </v-flex>
      <v-flex
        xs12
        class="description"
        v-html="agreement.displayText"></v-flex>
      <v-layout row mb-4>
        <v-flex xs6 mr-2>
          <v-btn
            @click="handleCancel"
            large
            depressed
            outline
            block
            class="control--yes grey-text">{{ agreement.buttonTextCancel || 'No' }}</v-btn>
        </v-flex>
        <v-flex xs6 mr-2>
          <v-btn
            @click="handleContinue"
            large
            color="#ffa424"
            depressed
            class="control--yes black--text"
            block
            :disabled="!formValid">{{ agreement.buttonTextContinue || 'Yes' }}</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="showOptInBox" class="cellphone-opt-container">
        <div class="cellphone-opt-container__fields">
          <b>Preferred Phone Number</b>
          <v-layout wrap>
            <v-flex xs5 mr-2>
              <v-text-field
                v-model="value.phoneNumber"
                :rules="phoneRules"
                @input="$emit('phoneEdited', $event)"
                label="Phone number"
                mask="###-###-####"
                autocomplete="tel-national"
                name="tel-national">
              </v-text-field>
            </v-flex>
            <v-flex xs5 ml-2>
              <v-select
                v-model="value.phoneType"
                label="Phone type"
                :hide-details="true"
                :items="phoneTypes"
                :rules="phoneTypeRules"
                :menu-props="{ auto: true }"
                ref="select-input-common"/>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="row tcpa" v-if="showTCPALegal && showOptInBox">
        <v-checkbox
          :value="acceptTCPALegal"
          @change="$emit('tcpaLegalEvent', $event)"
          :rules="legalCheckboxRules">
          <template slot="label">
            <span class="offers__option__label">
              I agree to be contacted at this phone number with the terms listed below
            </span>
          </template>
        </v-checkbox>
      </div>
      <v-divider></v-divider>
      <input
        id="leadid_token"
        name="universal_leadid"
        type="hidden"/>
      <input type="hidden" id="leadid_tcpa_disclosure"/>
      <v-flex v-html="finePrintHTML" mb-2></v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      phoneTypeRules: [v => !!v || 'Phone type is required'],
      phoneRules: [v => v.length === 0 || v.length === 10 || 'Phone must be equal 10 digits'],
      phoneTypes: ['Work', 'Mobile', 'Home'],
      legalCheckboxRules: [
        v => !!v || 'Check is required',
      ],
    };
  },
  props: {
    agreementDisplayLabel: {
      required: true,
      type: String,
    },
    agreement: {
      required: true,
      type: Object,
    },
    formValid: {
      required: true,
      type: Boolean,
    },
    requestAgreementLoading: {
      required: true,
      type: Boolean,
    },
    showOptInBox: {
      required: true,
      type: Boolean,
    },
    showLegalTextBelowContinueButton: {
      required: true,
      type: Boolean,
    },
    showTCPALegal: {
      required: true,
      type: Boolean,
    },
    acceptTCPALegal: {
      required: true,
      type: Boolean,
    },
    truncatedLegalTextEnabled: {
      required: true,
      type: Boolean,
    },
    value: {
      required: true,
      type: Object,
    },
  },
  computed: {
    agreementDisplayImage() {
      // eslint-disable-next-line prefer-template
      return `${process.env.VUE_APP_CLOUDFRONT_MEDIA_URL}${this.agreement.displayImage ?? this.agreement.agreementId + '.png'}`;
    },
    verticalsChecked() {
      return this.agreement.offers.some((offer => offer.selected));
    },
    finePrintHTML() {
      const legalText = this.agreement.displayFinePrint || '';
      return `<label for="leadid_tcpa_disclosure">${legalText}</label>`;
    },
  },
  methods: {
    handleContinue() {
      if (this.verticalsChecked) {
        this.$emit('submit');
      } else {
        this.$emit('verticalsEvent', true);
        if (!this.showTCPALegal) {
          setTimeout(() => {
            this.$emit('submit');
          }, 0);
        }
      }
    },
    handleCancel() {
      this.$emit('verticalsEvent', false);
      setTimeout(() => {
        this.$emit('submit');
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.75;
  margin-top: 24px;
  margin-bottom: 24px;
}
.cellphone-opt-container {
  color: #2d2d2d;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.75;
  &__fields {
    font-size: 16px;
    display: flex;
    flex-direction: column;
  }
}
.row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 5px;
  &.tcpa {
    justify-content: flex-end;
    .v-input {
      flex: 0 1 content;
    }
  }
}
hr {
  margin-top: 0;
  margin-bottom: 24px;
}
</style>
